import { signInWithPopup } from 'firebase/auth';
import { auth, provider } from '../firebase/firebase';


const dbUserFromUser = async (user) => {
    try {

        console.log('✅ Current user 🔥:', user.displayName);

        // Prepare the data to send
        const userData = user;

        // Make the POST request
        const response = await fetch('https://bluejims.com:5005/youknow/access', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(user),
        });

        if (response.ok) {
            console.log('✅ User data successfully received from netofcomputers.com');
            // You can parse the response if the server sends back any data
            const responseData = await response.json();
            console.log('Server response:', responseData);
            // TODO: navigate to dashboard or store user info
            return responseData.user
        } else {
            console.error('❌ Failed to receive user data from netofcomputers.com:', response.status, response.statusText);
            // Handle non-2xx responses
            return false
        }

    } catch (error) {
        console.error('❌ DataApi /access* or fetch error:', error);
        return false
    }
};

export default dbUserFromUser;